// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import * as S from './JobDrawerHeader.styles';

interface JobDrawerHeaderProps {
  title: string;
  onClose: () => void;
  showBackButton: boolean;
  onBack?: () => void;
}

export const JobDrawerHeader = ({
  title,
  onClose,
  showBackButton,
  onBack,
}: JobDrawerHeaderProps) => {
  return (
    <S.CenteredFlex>
      {showBackButton && onBack && (
        <S.BackButton>
          <Button
            icon="back"
            variant="ghost"
            onClick={onBack}
            data-test="launch-drawer-back"
            size="large"
          />
        </S.BackButton>
      )}
      <S.Header>{title}</S.Header>
      <S.CloseButton>
        <Button
          icon="close"
          variant="ghost"
          onClick={onClose}
          data-test="launch-drawer-close"
          size="large"
        />
      </S.CloseButton>
    </S.CenteredFlex>
  );
};
